module.exports = __webpack_public_path__ + "static/img/WI-XB400.ebae46a1.jpg";